import React from 'react';

import { Badge } from '@ergeon/core-components';

export const KeyboardKey: React.FC<{keys: string[]}> = ({ keys }) => {
  return (
    <div className="flex gap-1">
      {keys.map((key, index) => (
        <div className="flex justify-center items-center gap-1" key={index}>
          {index > 0 && <span className="text-gray-500 paragraph-2">+</span>}
          <Badge flavor="regular" shape="square" taste="line" value={key} />
        </div>
      ))}
    </div>
  );
};
